import Error from '../model/Error.js';
import SepaCreditTransferExport from '../dto/SepaCreditTransferExport.js';
import SepaCreditTransferExportAvailability from '../dto/SepaCreditTransferExportAvailability.js';
import axios from 'axios';

export default class SepaCreditTransferExportRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sepa-credit-transfer-exports`)
                .then((response) => resolve(response.data.data.map((data) => SepaCreditTransferExport.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getAvailabilityByClubAndQuery(clubId, query) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/sepa-credit-transfer-exports/availability${query}`)
                .then((response) => resolve(SepaCreditTransferExportAvailability.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static createByClub(clubId, start, end, params) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/clubs/${clubId}/sepa-credit-transfer-exports?dateRange=${start}:${end}`, params)
                .then((response) => resolve(response))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static download(exportId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/sepa-credit-transfer-exports/${exportId}`, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const headerLine = response.headers['content-disposition'];
                    const startFileNameIndex = headerLine.indexOf('"') + 1;
                    const endFileNameIndex = headerLine.lastIndexOf('"');
                    const filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    resolve();
                })
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(exportId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/sepa-credit-transfer-exports/${exportId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
